import { authority } from "../shared/security/authority";

const routes = [
  {
    path: "/change-password",
    name: "changePassword",
    component: () => import("../views/ChangePassword.vue"),
    meta: {
      authorities: [
        authority.ADMIN.role,
        authority.EMPLOYEE.role,
        authority.CONSULTANT.role,
        authority.COMPANY.role
      ]
    }
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("../views/Privacy.vue"),
  },
  {
    path: "/faq",
    name: "faq",
    component: () => import("../views/Faq.vue"),
    meta: {
      authorities: [
        authority.ADMIN.role,
        authority.EMPLOYEE.role,
        authority.CONSULTANT.role,
        authority.COMPANY.role
      ]
    }
  },
  {
    path: "/account/reset/init",
    name: "reset-init",
    component: () => import("../views/ResetPasswordInit.vue")
  },
  {
    path: "/account/reset/finish",
    name: "reset-finish",
    component: () => import("../views/ResetPasswordFinish.vue")
  },
  {
    path: "/account/activate",
    name: "activate",
    component: () => import("../views/Activate.vue")
  },
  {
    path: "/userdata",
    name: "userdata",
    component: () => import("../views/UserData.vue"),
    meta: {
      authorities: [
        authority.COMPANY.role,
        authority.CONSULTANT.role,
        authority.EMPLOYEE.role,
      ]
    }
  },
];

export default routes;
